import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';
import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/uikitInsigniasInsignia.module.scss';

const Insignia = ({
  ariaLabel = '',
  className = '',
  icon = null,
  iconSize = 12,
  shouldShowInsigniasSeparator = false,
  shouldShowInsigniasText = true,
  testId = '',
  text = '',
  textVariant = '',
  tooltip = '',
}) => {
  const IconComponent = createIconComponent({ icon, size: iconSize, className: styles.icon });

  return (
    <div
      className={classnames(styles.element, className)}
      key={`insignia_${text}`}
      data-testid={testId}
    >
      {tooltip ? (
        <Tooltip content={tooltip} placement="top">
          <div className={styles.content}>{IconComponent}</div>
        </Tooltip>
      ) : (
        IconComponent
      )}
      {shouldShowInsigniasText && (
        <div
          className={classnames(styles.text, {
            [styles.hasSeparator]: shouldShowInsigniasSeparator,
          })}
        >
          <Typo color="inherit" element="span" variant={textVariant || 's01'}>
            {ariaLabel ? (
              <>
                <span aria-hidden>{text}</span>
                <span className={styles.ariaText}>{ariaLabel}</span>
              </>
            ) : (
              text
            )}
          </Typo>
        </div>
      )}
    </div>
  );
};

Insignia.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
  text: PropTypes.string,
  textVariant: PropTypes.string,
  tooltip: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  iconSize: PropTypes.number,
  shouldShowInsigniasSeparator: PropTypes.bool,
  shouldShowInsigniasText: PropTypes.bool,
};

export default React.memo(Insignia);
